import { useState,useEffect } from 'react';
import LocalOfferIcon from '@mui/icons-material/AccessAlarm';
import FindReplace from '@mui/icons-material/FindReplace';
import Assignment from '@mui/icons-material/Assignment';
import { WrapperIndicator } from './styles';
import { getTotalesRepT} from "../../../../../app/store/fuse/reportes-tickets";
import {useDispatch, useSelector} from "react-redux";

const IndicadoresGeneral = () => {
  const dispatch = useDispatch();
  const initTotales= () => dispatch(getTotalesRepT());
  const totales = useSelector((state) => state.fuse?.reportesTickets?.totales);
  
  const fixedProm = (total) =>{
    return total ? Number(total).toFixed(2):0
  }

  useEffect(() => {
    initTotales()
  }, []);
  
  return (
    <WrapperIndicator>
      <div className="section-info">
        <div className="w-1/3">
          <div className={"section-indicator-0"}>
            <div className="section-icon">
              <Assignment fontSize="medium"/>
            </div>
            <div className="section-text">
              <strong>Tickets Abiertos</strong>
              <strong>{totales.ticketsAbiertos}</strong>
            </div>
          </div>
        </div>
        <div className="w-1/3">
          <div className={"section-indicator-1"}>
            <div className="section-icon">
              <FindReplace fontSize="large"/>
            </div>
            <div className="section-text">
              <strong>Tickets en Curso</strong>
              <strong>{totales.ticketsEnProceso}</strong>
            </div>
          </div>
        </div>
        <div className="w-1/3">
          <div className={"section-indicator-2"}>
            <div className="section-icon">
              <LocalOfferIcon fontSize="large"/>
            </div>
            <div className="section-text">
              <strong>Tiempo Promedio de Solución</strong>
              <strong>{fixedProm( totales.promedioTiempoSolucion)} hrs</strong>
            </div>
          </div>
        </div>
      </div>
    </WrapperIndicator>
  );
};

export default IndicadoresGeneral;
